import type { AuthCache } from "../auth-store/cache";
import type { Role } from "./permissions";
import { hasMinimumRole } from "./permissions";

export function hasRole(cache: AuthCache, requiredRole: Role): boolean {
  const user = cache.getUser();
  if (!user) {
    return false;
  }
  return hasMinimumRole(user.role, requiredRole);
}
